export default __webpack_public_path__ + "static/media/first_engagement_card.672bf963.svg";